export default __webpack_public_path__ + "static/media/tfosqp.bb092a0f.webp";